export default {

	state: {
		groups: [],
		loaded: false,
    },

	actions: {
		fetchGroups({commit, state}) {
			if (state.groups === undefined || state.groups.length == 0){
				axios.get('/api/groups').then(({ data }) => {
					commit('setGroups', data);
				});
			}
		},

		addNewGroup({commit}, data) {
			commit('setNewGroup', data);
		},

		removeGroups({commit}, data) {
			commit('spliceGroups', data);
		},

		updateGroup({commit}, data) {
			commit('setGroupData', data)
		},			
	},

    mutations: {
		setGroups(state, groups) {
			state.groups = groups;
			state.loaded = true;
			this.state.config.loaded.groups = true;
		},

		setNewGroup(state, data) {
			state.groups.push(data);
			this._vm.$root.$emit('group_added', true);
			this._vm.$root.$emit('providers_changed', true);
		},

		setGroupData(state, data) {
			Object.assign(state.groups[state.groups.findIndex(group => group.id === data.id)], data);
			this._vm.$root.$emit('providers_changed', true);
		},

		spliceGroups(state, data) {
			data.forEach(id => {				
				state.groups.splice(state.groups.findIndex(group => group.id === id), 1);
			});
			this._vm.$root.$emit('providers_changed', true);
		},		
    },

    getters: {
		allGroupIds(state, getters) {
			return state.groups
				.map(group => ({
					code: 'group_' + group.id,
					//id : group.id,
					display_name : group.display_name,
					morphable_id : group.id,
					type : 'Group',
					morphable_type : 'App\\Group',
				}))
				.sort((a, b) => a.display_name.localeCompare(b.display_name));
		},

		mappableGroupIds(state, getters) {
			return state.groups
				.filter(group => group.location_primary && group.location_primary.latitude && group.location_primary.longitude)
				.map(group => ({
					code: 'group_' + group.id,
					//id : group.id,
					display_name : group.display_name,
					type : 'Group',
					morphable_id : group.id,
					morphable_type : 'App\\Group',
					location_id : group.location_primary.id,
					short_address : group.location_primary.short_address,
				}))
				.sort((a, b) => a.display_name.localeCompare(b.display_name));
		},

		nearbyGroupIds: (state) => (params) => {
			//3rd decimal is about 110m of precision
        	//https://gis.stackexchange.com/questions/8650/measuring-accuracy-of-latitude-and-longitude
			return state.groups
				.filter(group => group.locations
					.some(location => 
						location.latitude  <= (params.latitude + .002) && 
						location.latitude  >= (params.latitude - .002) && 
						location.longitude <= (params.longitude + .002) && 
						location.longitude >= (params.longitude - .002)
					)
				)
				.map(group => ({
					code: 'group_' + group.id,
					//id : group.id,
					display_name : group.display_name,
					type : 'group',
					morphable_id : group.id,
					morphable_type : 'App\\Group',
					location_id : group.locations.filter(location => 
						location.latitude  <= (params.latitude + .002) && 
						location.latitude  >= (params.latitude - .002) && 
						location.longitude <= (params.longitude + .002) && 
						location.longitude >= (params.longitude - .002))[0].id,
					short_address : group.locations.filter(location => 
						location.latitude  <= (params.latitude + .002) && 
						location.latitude  >= (params.latitude - .002) && 
						location.longitude <= (params.longitude + .002) && 
						location.longitude >= (params.longitude - .002))[0].short_address,
				}));
		}		
    }
};